module.exports = __webpack_public_path__ + "static/media/CHN.d096c0d5.png";